export enum ProfessionType {
    eMatica = 1,
    NISOO = 2
}